import { IconNames } from '@blueprintjs/icons';
import { DateFormats, formatDate } from '@strata/helper-functions';
import { type ColumnDef, Grid, SecondaryData } from '@strata/react-grid';
import { Icon } from '@strata/react-status-icons';
import { type ComponentProps } from 'react';

import { type ServiceBusMessage } from 'api/oopsAPI';

const columns: ColumnDef<ServiceBusMessage>[] = [
    {
        accessorKey: 'id',
        header: 'ID',
        size: 60,
    },
    {
        accessorKey: 'body',
        header: 'Body',
        size: 200,
        cell: ({ getValue }) => <SecondaryData data={JSON.stringify(getValue())} />,
    },
    {
        accessorKey: 'enqueued_timestamp',
        header: 'Timestamp',
        size: 40,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    {
        accessorKey: 'error',
        header: 'Parsing Error',
        size: 40,
        cell: ({ getValue }) => (
            <SecondaryData
                customTooltipContent={null}
                data={
                    getValue() && (
                        <Icon
                            icon={IconNames.ERROR}
                            intent={Icon.Intent.ERROR}
                            title="Error"
                            tooltipContent={getValue()?.msg}
                        />
                    )
                }
            />
        ),
    },
];

interface DeadLetterMessagesGridProps {
    messagesFetching: boolean;
    onRowClick: ComponentProps<typeof Grid<ServiceBusMessage>>['onRowClick'];
    messages: ServiceBusMessage[];
}

export const DeadLetterMessagesGrid = ({
    messagesFetching,
    messages,
    onRowClick,
}: DeadLetterMessagesGridProps) => (
    <Grid isLoading={messagesFetching} onRowClick={onRowClick} columns={columns} data={messages} />
);
